const ConvertToCustomTemplateEnum = {
  CONVERT_TO_CUSTOM_TEMPLATE_FROM_DOCUMENT_TYPE: 'CONVERT_TO_CUSTOM_TEMPLATE_FROM_DOCUMENT_TYPE',
  CONVERT_TO_CUSTOM_TEMPLATE_FROM_SHARE_KEY: 'CONVERT_TO_CUSTOM_TEMPLATE_FROM_SHARE_KEY',
  CONVERT_TO_CUSTOM_TEMPLATE_FROM_DOCUMENT_TYPE_FAILURE: 'CONVERT_TO_CUSTOM_TEMPLATE_FROM_DOCUMENT_TYPE_FAILURE',
  CONVERT_TO_CUSTOM_TEMPLATE_FROM_SHARE_KEY_FAILURE: 'CONVERT_TO_CUSTOM_TEMPLATE_FROM_SHARE_KEY_FAILURE',
};

export default ConvertToCustomTemplateEnum;



// WEBPACK FOOTER //
// ./src-react/ConvertToCustomTemplate/ConvertToCustomTemplateEnum.jsx